import { ResponsiveImageDimensions } from '../utils/ResponsiveImage/ResponsiveImage.models';

export const presetMediaDimensions: ResponsiveImageDimensions = {
  MQ1: [480, 480],
  MQ2: [768, 768],
  MQ3: [1024, 576],
  MQ4: [1280, 720],
  MQ5: [1440, 810],
  MQ6: [1920, 1080]
};
